import { useState, useEffect } from 'react';
import { fetchAuditionById } from '../services/auditionService';

/**
 * @hook useAuditionDetail
 * @description 공고 단건 상세 조회 훅
 *
 * 4-state: loading / error / notFound / success
 *
 * @param {string} id - URL 파라미터 id
 * @returns {{
 *   data: AuditionDetail | null,
 *   isLoading: boolean,
 *   isError: boolean,
 *   isNotFound: boolean,
 *   retry: Function,
 * }}
 */
function useAuditionDetail(id) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);

  const load = async () => {
    setIsLoading(true);
    setIsError(false);
    setIsNotFound(false);
    try {
      const result = await fetchAuditionById(id);
      setData(result);
    } catch (err) {
      if (err.message === 'NOT_FOUND') {
        setIsNotFound(true);
      } else {
        setIsError(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { data, isLoading, isError, isNotFound, retry: load };
}

export default useAuditionDetail;
